export default __webpack_public_path__ + "38ecc5cdbc1f20f71cfecfae2b02a02d.png";